(function () {
  var yen = new Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY",
    maximumFractionDigits: 0
  });

  function daysLeft(endsAt) {
    var diff = Date.parse(endsAt) - Date.now();
    if (Number.isNaN(diff)) return "";
    if (diff <= 0) return "終了";
    return "残り" + Math.ceil(diff / 86400000) + "日";
  }

  function daysUntil(startsAt) {
    var diff = Date.parse(startsAt) - Date.now();
    if (Number.isNaN(diff) || diff <= 0) return "";
    return Math.ceil(diff / 86400000) + "日";
  }

  function formatDate(value) {
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    return date.getMonth() + 1 + "/" + date.getDate();
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  var returnMeta = {
    "super-early-1": {
      image: "mo-return-super-early-1.png"
    },
    "early-1": {
      image: "mo-return-early-1.png"
    },
    "reservation-1": {
      image: "mo-return-reservation-1.png"
    },
    "recommend-2": {
      image: "mo-return-recommend-2.png"
    },
    "continue-3": {
      image: "mo-return-continue-3.png"
    }
  };

  function assetUrl(filename) {
    var script = document.currentScript || document.querySelector('script[src*="marvelousone-crowdfunding-widget.js"]');
    var source = script?.src || "";
    var base = source.split("?")[0].replace(/[^/]*$/, "");
    return base + encodeURIComponent(filename);
  }

  function renderVariant(variant) {
    var meta = returnMeta[variant.id] || {};
    var image = meta.image ? assetUrl(meta.image) : "";
    var limit = Number(variant.limit || 0) > 0 ? "限定" + Number(variant.limit) + "名" : "数量限定";
    var deliveryText = variant.deliveryLabel ? " / 提供予定 " + variant.deliveryLabel : "";
    var alt = [variant.title, yen.format(variant.price || 0), limit + deliveryText].filter(Boolean).join(" ");

    if (!image) {
      return [
        '<article class="mo-cf-widget__return-card mo-cf-widget__return-card--fallback">',
        "<strong>" + escapeHtml(variant.title) + "</strong>",
        "<span>" + escapeHtml(limit + deliveryText) + "</span>",
        '<div class="mo-cf-widget__return-fallback-price">' + yen.format(variant.price || 0) + "</div>",
        "</article>"
      ].join("");
    }

    return [
      '<article class="mo-cf-widget__return-card">',
      '<img class="mo-cf-widget__return-image" src="' + image + '" alt="' + escapeHtml(alt) + '" loading="lazy">',
      "</article>"
    ].join("");
  }

  function render(widget, data) {
    var percent = Number(data.percent || 0);
    var safePercent = Math.min(100, Math.max(0, percent));
    var accepting = data.accepting !== false;
    var badgeText = data.hasEnded ? "受付終了" : accepting ? "予約受付中" : "受付開始前";
    var dateLabel = data.hasEnded ? "状態" : accepting ? "残り" : "開始まで";
    var dateValue = data.hasEnded ? "終了" : accepting ? daysLeft(data.endsAt).replace("残り", "") : daysUntil(data.startsAt);
    var ctaText = accepting ? "リターンを見る" : "受付開始までお待ちください";
    widget.style.setProperty("--mo-cf-accent", data.accentColor || widget.style.getPropertyValue("--mo-cf-accent"));
    widget.classList.toggle("mo-cf-widget--locked", !accepting);
    widget.innerHTML = [
      '<div class="mo-cf-widget__hero">',
      '<div class="mo-cf-widget__topline">',
      '<h2 class="mo-cf-widget__title">' + escapeHtml(data.title || "先行予約キャンペーン") + "</h2>",
      '<span class="mo-cf-widget__badge">' + badgeText + "</span>",
      "</div>",
      '<span class="mo-cf-widget__amount-label">応援購入総額</span>',
      '<div class="mo-cf-widget__amount">',
      "<strong>" + yen.format(data.currentAmount || 0) + "</strong>",
      '<span class="mo-cf-widget__goal">目標 ' + yen.format(data.goalAmount || 0) + "</span>",
      "</div>",
      '<div class="mo-cf-widget__track-wrap">',
      '<div class="mo-cf-widget__track"><div class="mo-cf-widget__bar" style="width:' + safePercent + '%"></div><span class="mo-cf-widget__percent">' + percent.toFixed(1) + "%</span></div>",
      "</div>",
      '<div class="mo-cf-widget__metrics">',
      '<div class="mo-cf-widget__metric"><span>購入者数</span><strong>' + (data.currentCount || 0) + "件</strong></div>",
      '<div class="mo-cf-widget__metric"><span>' + dateLabel + "</span><strong>" + escapeHtml(dateValue || "-") + "</strong></div>",
      "</div>",
      accepting
        ? '<a class="mo-cf-widget__cta" href="#mo-cf-rewards">' + ctaText + "</a>"
        : '<span class="mo-cf-widget__cta mo-cf-widget__cta--disabled" aria-disabled="true">' + ctaText + "</span>",
      "</div>",
      '<div class="mo-cf-widget__body">',
      data.label ? '<p class="mo-cf-widget__label">' + escapeHtml(data.label) + "</p>" : "",
      '<div id="mo-cf-rewards" class="mo-cf-widget__rewards">',
      (data.variants || []).map(renderVariant).join(""),
      "</div>",
      "</div>"
    ].join("");
  }

  function lockPurchaseControls() {
    var selectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      'product-form button[type="submit"]',
      ".shopify-payment-button button",
      '[name="add"]'
    ];
    document.querySelectorAll(selectors.join(",")).forEach(function (button) {
      if (button.dataset.moCfLocked === "1") return;
      button.dataset.moCfLocked = "1";
      button.dataset.moCfOriginalText = button.textContent;
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
      button.classList.add("mo-cf-purchase-locked");
      if (button.textContent.trim()) button.textContent = "受付開始前";
    });
  }

  async function hydrate(widget) {
    var endpoint = widget.dataset.endpoint || "/apps/mo-crowdfunding/campaign";
    var handle = widget.dataset.productHandle;
    var separator = endpoint.indexOf("?") >= 0 ? "&" : "?";
    var response = await fetch(endpoint + separator + "product_handle=" + encodeURIComponent(handle), {
      headers: { accept: "application/json" }
    });

    if (response.status === 404) {
      widget.hidden = true;
      return;
    }

    if (!response.ok) throw new Error("Failed to load campaign: " + response.status);
    var data = await response.json();
    render(widget, data);
    if (data.accepting === false) lockPurchaseControls();
  }

  document.querySelectorAll("[data-mo-cf-widget]").forEach(function (widget) {
    hydrate(widget).catch(function () {
      if (window.Shopify && window.Shopify.designMode) {
        widget.innerHTML = '<div class="mo-cf-widget__error">キャンペーン情報を表示できませんでした。</div>';
        return;
      }

      widget.hidden = true;
    });
  });
})();
